export const EVENTO_ABRIR_SELETOR_EMPRESA = "i9:abrir-seletor-empresa";

export interface DetalheAbrirSeletorEmpresa {
  ancora: HTMLElement;
}

/** Abre o seletor compartilhado de organização/empresa ancorado no elemento informado. */
export function abrirSeletorEmpresa(ancora: HTMLElement) {
  window.dispatchEvent(
    new CustomEvent<DetalheAbrirSeletorEmpresa>(EVENTO_ABRIR_SELETOR_EMPRESA, {
      detail: { ancora },
    })
  );
}
